/* eslint-disable promise/catch-or-return */
import InfiniteScroll from 'infinite-scroll';
import jQuery from 'jquery';
import axios from 'axios';
import { trackingApiUrl } from '../_helpers/constants';
import Carousels from './carousels';

export default class InfiniteArticle {}
(function ($, d, w) {
  const items = d.querySelectorAll('.oc-lateral-item');

  w.InfiniteScroll = InfiniteScroll;
  w.InfScrollLoad = initScripts;
  w.PushAnalytics = initPushAnalytics;

  w.addons = w.addons || {};

  w.addons.infiniteScroll = {
    getItemData,
  };

  function initScripts() {
    // init carousel js
    w.carousels = new Carousels();
    // init sharebar js
    w.addons_sharebar($, d, w);
  }

  function getItemData() {
    const jwPlayerId = window.jwPlayerId || '';
    const item = items[this.loadCount];
    if (!item) {
      return;
    }

    const options = JSON.parse(item.dataset.options);
    return `/api/tenniscom/article/lazy/${item.dataset.slug}?related=${options.HideRelatedItems}&share=${options.HideSocialShare}&roof=${options.HideRoofline}&desc=${options.HideDescription}&date=${options.HideDate}&author=${options.HideAuthor}&scroll=${options.IsInfiniteScroll}&advfrequency=${options.AdvFrequency}&targetingkeyvalues=${options.TargetingKeyValues}&jwplayerid=${jwPlayerId}`;
  }

  function initPushAnalytics(data) {
    const GTagDimensionsEntity = {
      dimension1: '',
      dimension2: '',
      dimension3: '',
      dimension4: '',
      dimension5: '',
      dimension6: '',
    };

    if (data.itemData) {
      GTagDimensionsEntity.dimension1 = data.itemData._entityId;
      GTagDimensionsEntity.dimension2 = data.itemData._translationId;
      GTagDimensionsEntity.dimension3 = data.itemData.Title;
      GTagDimensionsEntity.dimension4 = data.itemData.Type;
      GTagDimensionsEntity.dimension5 = 'en-US';

      const authors = data.itemData.Tags.filter(
        // eslint-disable-next-line eqeqeq
        (tag) => tag.ExternalSourceName == 'customentity.author'
      );

      if (authors.length > 0) {
        const author = authors[0];

        GTagDimensionsEntity.dimension6 = author.Title;
      }
    }

    window.dataLayer = window.dataLayer || [];
    function gtag() {
      // eslint-disable-next-line no-undef
      dataLayer.push(arguments);
    }
    gtag('js', new Date());
    gtag('set', GTagDimensionsEntity);
    // eslint-disable-next-line no-undef
    gtag('config', gaKey);

    const $advData = $(data.itemHTML).find(
      'script[data-type="adv-lazy-load-data-infinite-scroll"]'
    );

    if ($advData.length) {
      $advData.each(function () {
        parse(this.innerText);
      });
    }

    if (self.COMSCORE && window.comescorePublisherId) {
      // eslint-disable-next-line no-undef
      self.COMSCORE && COMSCORE.beacon({ c1: '2', c2: window.comescorePublisherId });

      axios.get(`${trackingApiUrl}?v=${Math.random()}`).then((resp) => {
        return resp;
      });
    }
  }

  function parse(str) {
    // eslint-disable-next-line no-new-func
    return Function(str)();
  }
})(jQuery, document, window);
